import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemProdutoDetalharComponent } from './item-produto-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ItemProdutoDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class ItemProdutoDetalharRoutingModule { }
